import React, { useEffect, useState } from "react";
import Task from "../../assets/task.png";
import Completed from "../../assets/checked.png";
import Pending from "../../assets/work-in-progress.png";
import Urgent from "../../assets/alarm.png";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  IconButton,
  useMediaQuery,
  Typography,
  TablePagination,
  TextField,
  Autocomplete,
  Modal,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import commonapihandler from "../../common/commonapihandler";
import { getHubName } from "../../api/api";
import formatDateAndTime from "../../common/formatDateAndTime";
import { BlinkBlur } from "react-loading-indicators";
import toast from "react-hot-toast";
import moment from "moment";
import { camelToNormal } from "../../common/caseconversion";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import user from "../../assets/user.gif";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { useSelector } from "react-redux";
import getactions from "../../common/getactions";

const imagestyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 20,
  p: 4,
  overflowY: "auto",
  maxHeight: "80vh",
};

const imagestyleForConfirmation = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 200,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 20,
  p: 4,
  overflowY: "auto",
  maxHeight: "80vh",
};

// Helper to extract YYYY-MM-DD in local time without UTC offset shifts
const getLocalDateString = (dateInput) => {
  if (!dateInput) return "";
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return "";
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const resolveSalesAgentOption = (
  selectedSalesAgent,
  salesAgents = [],
) => {
  if (!selectedSalesAgent) return "";

  const selectedId = selectedSalesAgent?.id ?? selectedSalesAgent;
  if (selectedId === null || selectedId === undefined || selectedId === "") {
    return "";
  }

  const matchedAgent = salesAgents.find(
    (agent) => String(agent?.id) === String(selectedId),
  );

  return matchedAgent ? matchedAgent.id : selectedId;
};

const Coupons = () => {
  const ITEM_HEIGHT = 28;
  const ITEM_PADDING_TOP = 8;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
      },
    },
  };
  const isSystemUserDataList = useSelector((state) =>
    state?.isSystemUser?.isSysTemUserData?.entities?.rows.filter(
      (data) => data?.isSalesAgent === true,
    ),
  );
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const profile = JSON.parse(localStorage.getItem("profile"));

  let token = localStorage.getItem("token");
  const localTodayStr = getLocalDateString(new Date());
  const actionsToAccess = getactions(profile?.roles, profile?.actions);

  const initialFormState = {
    code: "",
    couponValue: null,
    status: null,
    discountType: null,
    city: null,
    minimumCap: null,
    maximumCap: null,
    usagePerCustomer: null,
    startDate: "",
    endDate: "",
    description: "",
    vehicleGroups: [],
  };

  let bookingTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  delete bookingTypes?.inverted;
  let bookingTypesDuplicate = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;

  const [form, setForm] = useState(initialFormState);
  const [couponConfig, setCoupons] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState(null);
  const [getAllHubsListData, setGetAllHubsListData] = useState(null);

  const [openModal, setOpenModal] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [cityname, setCity] = useState(null);
  const [error, setError] = useState("");
  const [vehicleGroups, setVehicleGroups] = useState([]);

  useEffect(() => {
    getAllBookingConfigsData(0);
  }, [cityname]);

  const handleModalClose = () => {
    setSelectedRow(null);
    setForm(initialFormState);
    setOpenModal(false);
    setError("");
  };

  function createData(
    id,
    couponcode,
    bookingType,
    cityName,
    isForSalesAgent,
    forAllBookingTypes,
    salesAgentDetails,
    validFrom,
    validTo,
    isActive,
    minimumCap,
    maximumCap,
    createdAt,
    action,
    raw,
  ) {
    return {
      id,
      couponcode,
      bookingType,
      cityName,
      isForSalesAgent,
      forAllBookingTypes,
      salesAgentDetails,
      validFrom,
      validTo,
      isActive,
      minimumCap,
      maximumCap,
      createdAt,
      action,
      raw,
    };
  }

  const columns = [
    { id: "id", label: "Id", minWidth: 70, align: "left" },
    { id: "couponcode", label: "Coupon Code", minWidth: 150, align: "left" },
    { id: "bookingType", label: "Booking Type", minWidth: 150, align: "left" },
    { id: "cityName", label: "City", minWidth: 150, align: "right" },
    {
      id: "isForSalesAgent",
      label: "Is For Sales Agent",
      minWidth: 200,
      align: "right",
    },
    {
      id: "forAllBookingTypes",
      label: "For All Booking Types",
      minWidth: 200,
      align: "right",
    },
    {
      id: "salesAgentDetails",
      label: "Sales Agent Details",
      minWidth: 250,
      align: "right",
    },
    { id: "validFrom", label: "Valid From", minWidth: 190, align: "right" },
    { id: "validTo", label: "Valid To", minWidth: 190, align: "right" },
    { id: "isActive", label: "Is Active", minWidth: 100, align: "right" },
    { id: "minimumCap", label: "Minimum Cap", minWidth: 150, align: "right" },
    { id: "maximumCap", label: "Maximum Cap", minWidth: 190, align: "right" },
    { id: "createdAt", label: "createdAt", minWidth: 190, align: "right" },
    { id: "action", label: "Action", minWidth: 90, align: "right" },
  ];

  const getVehicleGroupsDatAPI = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/vehiclegroups?limit=1000&cityId=${form?.city}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setVehicleGroups(data?.entities?.rows);
      } else {
        setVehicleGroups([]);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const getAllBookingConfigsData = async (
    customPage = page,
    customRowsPerPage = rowsPerPage,
  ) => {
    setLoading(true);
    const offset = customPage * customRowsPerPage;
    let query = `isAdminCall=true&limit=${customRowsPerPage}&offset=${offset}`;

    if (cityname) {
      query += `&cityId=${cityname}`;
    }

    try {
      const response = await fetch(`${apiUrl}/api/coupons?${query}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setCoupons(data?.entities?.rows);
        setTotalCount(data?.entities?.count || 0);
      }
      return data;
    } catch (error) {
      setLoading(false);
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "align",
    "link",
  ];

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  useEffect(() => {
    if (form?.city) {
      getVehicleGroupsDatAPI();
    }
  }, [form?.city]);

  useEffect(() => {
    getCityNames();
  }, []);

  const rows =
    couponConfig?.map((item) =>
      createData(
        item?.id,
        item?.couponCode,
        bookingTypesDuplicate[item?.bookingType] || "-",
        cities ? cities[item?.cityId] : item?.cityId,
        item?.isForSalesAgent ? "True" : "False",
        item?.validForAllBookingTypes ? "True" : "False",
        item?.salesAgentName + item?.salesAgentEmail,
        formatDateAndTime(item?.validFrom),
        formatDateAndTime(item?.validTo),
        item?.isActive ? "True" : "False",
        `₹ ${item?.minimumCap}`,
        `₹ ${item?.maximumCap}`,
        formatDateAndTime(item?.createdAt),
        "Edit",
        item,
      ),
    ) || [];

  const handleEditClick = (row) => {
    const raw = row.raw;
    setSelectedRow(raw);

    let parsedGroupIds = [];
    if (raw?.groupIds) {
      try {
        parsedGroupIds =
          typeof raw.groupIds === "string"
            ? JSON.parse(raw.groupIds)
            : raw.groupIds;
      } catch (e) {
        parsedGroupIds = [];
      }
    }

    setForm({
      code: raw?.couponCode || raw?.code || "",
      couponValue: Number(raw?.couponValue) || null,
      status: raw?.isActive ?? null,
      discountType: raw?.isPercentage ? "Is Percentage" : "Is Fixed",
      minimumCap: Number(raw?.minimumCap) || null,
      maximumCap: Number(raw?.maximumCap) || null,
      usagePerCustomer: Number(raw?.usagePerCustomer) || null,
      startDate: getLocalDateString(raw?.validFrom),
      endDate: getLocalDateString(raw?.validTo),
      city: raw?.cityId ? Number(raw.cityId) : null,
      description: raw?.description || "",
      vehicleGroups: parsedGroupIds,
      isForSalesAgent: raw?.isForSalesAgent,
      bookingType: raw?.bookingType,
      salesAgentDetails: {
        id: raw?.salesAgentId,
        email: raw?.salesAgentEmail,
        name: raw?.salesAgentName,
      },
      validForAllBookingTypes:
        raw?.validForAllBookingTypes === 1 ? true : false,
    });

    setOpenModal(true);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    getAllBookingConfigsData(0, newRowsPerPage);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllBookingConfigsData(newPage, rowsPerPage);
  };

  const EditPeakSeasonDetails = async () => {
    setError("");

    // Client-side date range validation
    if (form.startDate && form.endDate && form.endDate < form.startDate) {
      const errMsg = "End Date cannot be earlier than Start Date";
      setError(errMsg);
      return toast.error(errMsg);
    }

    const payload = {
      ...(selectedRow && { id: selectedRow.id }),
      couponCode: form?.code,
      couponValue: Number(form?.couponValue),
      minimumCap: Number(form?.minimumCap),
      maximumCap: Number(form?.maximumCap),
      usagePerCustomer: Number(form?.usagePerCustomer),
      validFrom: form?.startDate ? `${form.startDate}T00:00:00` : null,
      validTo: form?.endDate ? `${form.endDate}T23:59:59` : null,
      cityId: Number(form?.city),
      isActive: form?.status,
      description: form?.description,
      groupIds: JSON.stringify(form?.vehicleGroups || []),
      termAndConditions: form?.description,
      isPercentage: form?.discountType === "Is Percentage",
      isFixed: form?.discountType === "Is Fixed",
      bookingType: form?.bookingType ? form?.bookingType : null,
      isForSalesAgent: form?.isForSalesAgent,
      salesAgentId: form?.isForSalesAgent ? form?.salesAgentDetails?.id : 0,
      salesAgentName: form?.isForSalesAgent
        ? form?.salesAgentDetails?.name
        : null,
      salesAgentEmail: form?.isForSalesAgent
        ? form?.salesAgentDetails?.email
        : null,
      validForAllBookingTypes: form?.bookingType ? 0 : 1,
    };
    // return

    try {
      const response = await fetch(`${apiUrl}/api/coupons`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Coupon Added Successfully", {
          position: "top-end",
          style: {
            background: "green", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        await getAllBookingConfigsData();
        if (!selectedRow) {
          setOpenConfirmationModal(true);
        }
        // setForm(initialFormState);
        setError("");
        setSelectedRow(null);
        setOpenModal(false);
      } else {
        toast.error(data?.message || "Operation failed");
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error during submission:", error);
    }
  };

  const handleVehicleGroupChange = (event) => {
    const value = event.target.value;

    if (value[value.length - 1] === "all") {
      const allIds = vehicleGroups.map((item) => item.id);
      handleChange(
        "vehicleGroups",
        form.vehicleGroups?.length === vehicleGroups.length ? [] : allIds,
      );
      return;
    }

    handleChange(
      "vehicleGroups",
      value.filter((item) => item !== "all"),
    );
  };

  return (
    <div>
      {openConfirmationModal && (
        <Modal open={!!openConfirmationModal}>
          <Box sx={imagestyleForConfirmation}>
            <h1 className="text-md mb-4">
              Are you want to create a new Coupon with same details for
              different city or different sales agent ?
            </h1>
            <div className="flex gap-4 justify-end">
              <button
                onClick={() => {
                  setOpenModal(false);
                  setOpenConfirmationModal(false);
                  setForm(initialFormState);
                }}
                className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 bg-white hover:bg-gray-100 transition-all duration-200"
              >
                No
              </button>

              <button
                onClick={() => {
                  setOpenConfirmationModal(false);
                  setOpenModal(true);
                }}
                className="px-5 py-2 rounded-lg bg-[#EF3C23] text-white hover:bg-[#d9321c] transition-all duration-200 shadow-sm"
              >
                Yes
              </button>
            </div>
          </Box>
        </Modal>
      )}

      {openModal && (
        <Modal open={!!openModal} onClose={handleModalClose}>
          <Box sx={imagestyle}>
            <h1 className="text-xl mb-4">
              {selectedRow ? "Update Coupon Config" : "Create Coupon Config"}
            </h1>
            <div className="space-y-6 mt-8">
              <div className="grid grid-cols-3 gap-4">
                <FormControl fullWidth>
                  <InputLabel id="booking-type-label">Booking Type</InputLabel>
                  <Select
                    labelId="booking-type-label"
                    value={form.bookingType ?? ""}
                    onChange={(e) =>
                      handleChange("bookingType", e.target.value)
                    }
                    label="bookingType"
                  >
                    {bookingTypes &&
                      Object.entries(bookingTypes).map(([key, value]) => (
                        <MenuItem key={key} value={Number(key)}>
                          {value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="is-agent-label">
                    Is For Sales Agent
                  </InputLabel>
                  <Select
                    labelId="is-agent-label"
                    value={form.isForSalesAgent ?? ""}
                    onChange={(e) =>
                      handleChange("isForSalesAgent", e.target.value)
                    }
                    label="isForSalesAgent"
                  >
                    <MenuItem key="true" value={true}>
                      True
                    </MenuItem>
                    <MenuItem key="false" value={false}>
                      False
                    </MenuItem>
                  </Select>
                </FormControl>
                {form?.isForSalesAgent && (
                  <>
                    <FormControl fullWidth>
                      <InputLabel id="sales-agent-detail-label">
                        Sales Agent List
                      </InputLabel>
                      <Select
                        labelId="sales-agent-detail-label"
                        value={resolveSalesAgentOption(
                          form.salesAgentDetails,
                          isSystemUserDataList,
                        )}
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          const matchedAgent = isSystemUserDataList?.find(
                            (data) => String(data?.id) === String(selectedId),
                          );
                          handleChange(
                            "salesAgentDetails",
                            matchedAgent || null,
                          );
                        }}
                        label="salesAgentDetails"
                      >
                        {isSystemUserDataList &&
                          isSystemUserDataList?.map((data) => (
                            <MenuItem key={data?.id} value={data?.id}>
                              {`${data?.name || ""} ${data?.email || ""}`.trim()}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </>
                )}
                <TextField
                  fullWidth
                  type="text"
                  label="Code"
                  required
                  value={form.code}
                  onChange={(e) => handleChange("code", e.target.value)}
                />
                <TextField
                  fullWidth
                  type="number"
                  label="Coupon Value"
                  required
                  value={form.couponValue ?? ""}
                  onChange={(e) => handleChange("couponValue", e.target.value)}
                />
                <FormControl fullWidth>
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    value={form.status ?? ""}
                    onChange={(e) => handleChange("status", e.target.value)}
                    label="Status"
                  >
                    <MenuItem key="true" value={true}>
                      Active
                    </MenuItem>
                    <MenuItem key="false" value={false}>
                      In Active
                    </MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="discount-label">Discount Type</InputLabel>
                  <Select
                    labelId="discount-label"
                    value={form.discountType ?? ""}
                    onChange={(e) =>
                      handleChange("discountType", e.target.value)
                    }
                    label="Discount Type"
                  >
                    <MenuItem key="true" value="Is Percentage">
                      Is Percentage
                    </MenuItem>
                    <MenuItem key="false" value="Is Fixed">
                      Is Fixed
                    </MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="city-label">City</InputLabel>
                  <Select
                    labelId="city-label"
                    value={form.city ?? ""}
                    onChange={(e) => handleChange("city", e.target.value)}
                    label="City"
                  >
                    {cities &&
                      Object.entries(cities).map(([key, value]) => (
                        <MenuItem key={key} value={Number(key)}>
                          {value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  type="number"
                  label="Minimum Cap"
                  value={form.minimumCap ?? ""}
                  onChange={(e) => handleChange("minimumCap", e.target.value)}
                />
                <TextField
                  fullWidth
                  type="number"
                  label="Maximum Cap"
                  required
                  value={form.maximumCap ?? ""}
                  onChange={(e) => handleChange("maximumCap", e.target.value)}
                />
                <TextField
                  fullWidth
                  type="number"
                  label="Usage Per Customer"
                  required
                  value={form.usagePerCustomer ?? ""}
                  onChange={(e) =>
                    handleChange("usagePerCustomer", e.target.value)
                  }
                />
                <TextField
                  fullWidth
                  type="date"
                  label="Start Date"
                  required
                  value={form.startDate}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: localTodayStr,
                  }}
                  onChange={(e) => handleChange("startDate", e.target.value)}
                />

                <TextField
                  fullWidth
                  type="date"
                  label="End Date"
                  required
                  value={form.endDate}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: form.startDate || localTodayStr,
                  }}
                  onChange={(e) => handleChange("endDate", e.target.value)}
                />
              </div>
              <div className="w-full">
                <label className="block mb-2 font-medium">
                  Description <span className="text-red-500">*</span>
                </label>

                <ReactQuill
                  theme="snow"
                  value={form.description}
                  onChange={(value) => handleChange("description", value)}
                  modules={modules}
                  formats={formats}
                  placeholder="Enter description..."
                  className="bg-white"
                />
              </div>
              <FormControl fullWidth>
                <InputLabel id="vehicle-label">Vehicle Groups</InputLabel>

                <Select
                  labelId="vehicle-label"
                  multiple
                  MenuProps={MenuProps}
                  value={form.vehicleGroups || []}
                  onChange={handleVehicleGroupChange}
                  input={<OutlinedInput label="Vehicle Groups" />}
                  renderValue={(selected) =>
                    selected
                      .map((id) => {
                        const vehicle = vehicleGroups?.find(
                          (item) => item.id === id,
                        );
                        return vehicle?.name;
                      })
                      .filter(Boolean)
                      .join(", ")
                  }
                >
                  <MenuItem value="all">
                    <Checkbox
                      checked={
                        vehicleGroups?.length > 0 &&
                        form.vehicleGroups?.length === vehicleGroups?.length
                      }
                    />
                    Select All
                  </MenuItem>

                  {vehicleGroups?.map((data) => (
                    <MenuItem key={data.id} value={data.id}>
                      <Checkbox
                        checked={form.vehicleGroups?.includes(data.id)}
                      />
                      {data.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {error && <p className="text-red-600 text-center mt-6">{error}</p>}
            <div className="flex justify-center mt-10">
              <button
                onClick={() => {
                  EditPeakSeasonDetails();
                }}
                className="cursor-pointer bg-gradient-to-b from-indigo-500 to-indigo-600 shadow-[0px_4px_32px_0_rgba(99,102,241,.70)] px-6 py-3 rounded-xl border-[1px] border-slate-500 text-white font-medium group"
              >
                <div className="relative overflow-hidden">
                  <p className="group-hover:-translate-y-7 duration-[1.125s] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    {selectedRow ? "Update" : "Add"}
                  </p>
                  <p className="absolute top-7 left-0 group-hover:top-0 duration-[1.125s] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    {selectedRow ? "Update" : "Add"}
                  </p>
                </div>
              </button>
            </div>
          </Box>
        </Modal>
      )}

      <div className="flex flex-col mt-4 sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <div className="flex items-center justify-between mt-6">
          <div className="flex items-center gap-4">
            <h1 className="text-2xl font-bold">Coupon Config Dashboard</h1>
          </div>
        </div>
        {actionsToAccess?.includes("Create New Coupons") && (
          <button
            onClick={() => {
              setSelectedRow(null);
              setForm(initialFormState);
              setOpenModal(true);
            }}
            className="rounded-lg relative h-10 cursor-pointer flex items-center border border-green-500 bg-green-500 group hover:bg-green-500 active:bg-green-500 active:border-green-500 px-4"
          >
            <span className="text-gray-200 font-semibold mr-4 transform group-hover:translate-x-2 transition-all duration-300">
              Add New Coupon
            </span>
            <span className="absolute right-0 h-full w-10 rounded-lg bg-green-500 flex items-center justify-center transform group-hover:translate-x-0 group-hover:w-full transition-all duration-300">
              <svg
                className="svg w-8 text-white"
                fill="none"
                height="24"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                width="24"
              >
                <line x1="12" x2="12" y1="5" y2="19"></line>
                <line x1="5" x2="19" y1="12" y2="12"></line>
              </svg>
            </span>
          </button>
        )}
      </div>
      {/* 
<Box
  display="grid"
  gridTemplateColumns={{
    xs: "1fr",
    sm: "repeat(2, 1fr)",
    lg: "repeat(7, 1fr)",
  }}
  gap={2}
  mb={3}
>
  <h1 className="mt-2">Filter By :</h1>

  <FormControl fullWidth size="small">
    <InputLabel id="city-select-label">City</InputLabel>
    <Select
      labelId="city-select-label"
      id="city-select"
      value={cityname}
      onChange={handleCityChange}
    >
      {cities &&
        Object.entries(cities).map(([key, value]) => (
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        ))}
    </Select>
  </FormControl>
</Box>

<div className="w-full sm:w-auto flex justify-end sm:ml-auto gap-4 mt-16 sm:mt-0">
  <button
    onClick={() => {
      setCity(null);
    }}
    className="bg-red-400 text-white px-6 py-2 rounded-full shadow-md hover:bg-gray-500 transition"
  >
    Reset
  </button>
</div>
*/}
      <Paper
        sx={{
          boxShadow: 6,
          borderRadius: 2,
          mt: 4,
        }}
      >
        <TableContainer sx={{ overflowX: "scroll" }}>
          <Table stickyHeader aria-label="bookings table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    sx={{
                      backgroundColor: "#f8f7f6ff",
                      fontWeight: 300,
                    }}
                    key={column.id}
                    align={column.align || "left"}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    <div className="flex flex-col items-center h-40 justify-center">
                      <BlinkBlur
                        color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ) : rows?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    <h1 className="mt-10 text-lg font-bold">No Data Found</h1>
                  </TableCell>
                </TableRow>
              ) : (
                rows?.map((row, idx) => (
                  <TableRow hover key={idx}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell
                          sx={{
                            ...(column.id === "isActive"
                              ? {
                                  color:
                                    value === "True"
                                      ? "rgb(22, 66, 22)"
                                      : "rgb(141, 31, 16)",
                                  fontWeight: 900,
                                }
                              : {}),
                            ...(column.id === "isForSalesAgent"
                              ? {
                                  color:
                                    value === "True"
                                      ? "rgb(22, 66, 22)"
                                      : "rgb(141, 31, 16)",
                                  fontWeight: 900,
                                }
                              : {}),
                            ...(column.id === "forAllBookingTypes"
                              ? {
                                  color:
                                    value === "True"
                                      ? "rgb(22, 66, 22)"
                                      : "rgb(141, 31, 16)",
                                  fontWeight: 900,
                                }
                              : {}),
                          }}
                          key={column.id}
                          align={column.align}
                        >
                          {column.id === "action"
                            ? actionsToAccess?.includes(
                                "Update Coupons",
                              ) && (
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => handleEditClick(row)}
                                >
                                  Edit
                                </Button>
                              )
                            : value || "-"}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 20, 30, 40]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            ".MuiTablePagination-toolbar": {
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
            },
          }}
        />
      </Paper>
    </div>
  );
};

export default Coupons;
